import React, { useState } from "react";
import axios from "axios";
import "./forgotPassword.css";
import { Link } from "react-router-dom";
import { baseUrl } from "../../../enum/constant";

const ForgotPasswordModal = ({ isOpen, onRequestClose, onBackToLogin }) => {
  const [email, setEmail] = useState("");
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [code, setCode] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);

  const resetFields = () => {
    setEmail("");
    setCode("");
    setMessage("");
    setError("");
    setLoading(false);
    setPassword("");
    setIsOtpSent(false); // Make sure this is reset
    setConfirmPassword("");
    setShowPassword(false);
    setShowPassword1(false);
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");
    setLoading(true);

    try {
      if (isOtpSent) {
        if (password !== confirmPassword) {
          setError("Passwords do not match.");
          setLoading(false);
          return;
        }

        const payload = {
          email,
          code,
          password,
          password_confirmation: confirmPassword,
        };

        const response = await axios.post(
          `${baseUrl}api/reset-password`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        setMessage(response?.data?.message || "Password reset successfully!");
        setLoading(false);
        setTimeout(() => {
          resetFields();
          onRequestClose();
        }, 3000);
      } else {
        const response = await axios.post(
          `${baseUrl}api/password/forgot`,
          { email },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        setMessage(
          response?.data?.message ||
            "A 6-digit reset code has been sent to your email (valid for 3 minutes)."
        );
        setIsOtpSent(true);
        setLoading(false);
        setError("");
      }
    } catch (error) {
      console.error(error.response?.data || error);
      setError(error?.response?.data?.message || "An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    resetFields(); // Reset fields when modal is closed
    onRequestClose();
  };

  const toggleShow = () => {
    setShowPassword((prev) => !prev);
  };

  const toggleShow1 = () => {
    setShowPassword1((prev) => !prev);
  };

  if (!isOpen) {
    return null;
  }

  return (
    <>
      <div className="pop-main forgot-pass" onClick={handleClose}>
        <div className="pop-wrap" onClick={(e) => e.stopPropagation()}>
          <div className="modal-content">
            <form onSubmit={handleResetPassword}>
              <button
                type="button"
                onClick={handleClose}
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <div className="modal-header">
                <h5 className="modal-title">Reset your password</h5>
              </div>
              {error && (
                <div className="alert alert-danger text-center mt-3">
                  {error}
                </div>
              )}
              {message && (
                <div className="alert alert-success text-center mt-3">
                  {message}
                </div>
              )}
              <div className="modal-body">
                {!isOtpSent ? (
                  <div className="fm-outer">
                    <label>Email</label>
                    <input
                      className="fm-cont"
                      type="email"
                      placeholder="Enter your email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>
                ) : (
                  <>
                    <div className="fm-outer">
                      <label>Code</label>
                      <input
                        style={{
                          letterSpacing: code ? "5px" : "0px",
                        }}
                        className="fm-cont"
                        type="text"
                        placeholder="Enter the code from email"
                        value={code}
                        onChange={(e) => setCode(e.target.value)}
                        required
                      />
                    </div>

                    <div className="fm-outer pass-view cus-pass-div">
                      <label>New Password</label>
                      <input
                        className="fm-cont"
                        type={showPassword ? "text" : "password"}
                        placeholder="Enter your new Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                      />
                      {showPassword ? (
                        <div className="eye-div" onClick={toggleShow}>
                          <img
                            className="eye-slash"
                            src="images/new/eye-slash.png"
                          />
                        </div>
                      ) : (
                        <div className="eye-div" onClick={toggleShow}>
                          <img className="eye" src="images/new/eye.png" />
                        </div>
                      )}
                    </div>

                    <div className="fm-outer pass-view cus-pass-div">
                      <label>Confirm Password</label>
                      <input
                        className="fm-cont"
                        type={showPassword1 ? "text" : "password"}
                        placeholder="Confirm your Password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                      />
                      {showPassword1 ? (
                        <div className="eye-div" onClick={toggleShow1}>
                          <img
                            className="eye-slash"
                            src="images/new/eye-slash.png"
                          />
                        </div>
                      ) : (
                        <div className="eye-div" onClick={toggleShow1}>
                          <img className="eye" src="images/new/eye.png" />
                        </div>
                      )}
                    </div>
                  </>
                )}
                <div className="button-group">
                  <button
                    type="submit"
                    className={`btn ${email ? "blue-btn" : "grey-btn"}`}
                    disabled={loading || (!email && !code)}
                  >
                    {loading ? "Sending..." : isOtpSent ? "Reset Password" : "Next"}
                  </button>
                </div>
                <div className="mt-3 new-t text-center">
                  <p>
                    <Link
                      to="#"
                      onClick={() => {
                        resetFields();
                        onBackToLogin();
                      }}
                      className="forgot"
                    >
                      Back to Sign In
                    </Link>
                  </p>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPasswordModal;